<div class="min-h-screen bg-[#fcfafa] py-12 px-4 sm:px-6 lg:px-8 font-sans">
  <!-- Header Title Section -->
   <!-- Back Button -->
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>
  <div class="max-w-4xl mx-auto text-center mb-16">
    <span class="inline-block px-3.5 py-1.5 rounded-full bg-primary/10 text-primary text-[11px] font-extrabold tracking-widest uppercase mb-3 font-mono">
      VIP MEMBERSHIP RATES
    </span>
    <h1 class="text-3xl sm:text-4xl lg:text-5xl font-display font-extrabold text-[#3a101e] tracking-tight m-0">
      Accelerate Your Partner Search
    </h1>
    <p class="mt-4 text-sm sm:text-base text-secondary/80 max-w-2xl mx-auto leading-relaxed m-0">
      Upgrade to verified premium access to unlock direct contact numbers, communicate instantly via chat, and receive AI-curated horoscopic compatibility matches.
    </p>

    <!-- Billing Cycle Toggle Ribbon -->
    <div class="mt-8 inline-flex items-center bg-white p-1.5 rounded-full border border-primary/10 shadow-sm">
      <button type="button" (click)="setBilling('monthly')"
        [ngClass]="billingCycle === 'monthly' ? 'bg-primary text-white shadow-md font-bold' : 'text-secondary/70 hover:text-primary font-medium'"
        class="px-6 py-2 rounded-full text-xs transition-all border-0 cursor-pointer">
        Monthly Billing
      </button>
      <button type="button" (click)="setBilling('annual')"
        [ngClass]="billingCycle === 'annual' ? 'bg-primary text-white shadow-md font-bold' : 'text-secondary/70 hover:text-primary font-medium'"
        class="px-6 py-2 rounded-full text-xs transition-all border-0 cursor-pointer flex items-center gap-1.5">
        <span>Annual Billing</span>
        <span class="bg-amber-500 text-white text-[9px] uppercase px-2 py-0.5 rounded-full font-extrabold">Save 20%</span>
      </button>
    </div>
  </div>

  <!-- Dynamic Enterprise SaaS Grid -->
  <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
    <div *ngFor="let plan of dynamicPlans" 
      [ngClass]="plan.plan_code === 'GOLD' || plan.plan_code === 'EXPRESS' ? 'bg-white text-secondary border-2 border-primary/30 shadow-xl scale-105 z-10' : 'bg-white text-secondary border border-secondary/15 shadow-md hover:shadow-xl'"
      class="relative rounded-3xl p-6 sm:p-7 flex flex-col justify-between transition-all duration-300">
      
      <div *ngIf="isPlanCurrent(plan.plan_code)"
        class="absolute -top-3 left-6 bg-emerald-600 text-white text-[10px] uppercase font-mono tracking-widest font-extrabold px-3 py-1 rounded-full shadow-md flex items-center gap-1 z-10">
        ✨ Current Plan
      </div>
      <div *ngIf="plan.plan_code === 'GOLD' && !isPlanCurrent(plan.plan_code)"
        class="absolute -top-3 right-6 bg-amber-500 text-white text-[10px] uppercase font-mono tracking-widest font-extrabold px-3 py-1 rounded-full shadow-md z-10">
        🔥 Most Popular
      </div>
      <div *ngIf="plan.plan_code === 'EXPRESS' && !isPlanCurrent(plan.plan_code)"
        class="absolute -top-3 right-6 bg-primary text-white text-[10px] uppercase font-mono tracking-widest font-extrabold px-3 py-1 rounded-full shadow-md z-10 flex items-center gap-1">
        👑 VIP Concierge
      </div>

      <div>
        <div class="flex items-center gap-3 mb-4">
          <div class="w-10 h-10 rounded-2xl flex items-center justify-center" [ngClass]="plan.plan_code === 'EXPRESS' ? 'bg-primary/10 text-primary' : 'bg-secondary/5 text-secondary'">
            <span class="material-symbols-outlined text-xl">{{ getPlanIcon(plan.plan_code) }}</span>
          </div>
          <div>
            <h3 class="text-lg font-bold m-0 text-[#3a101e]">{{ plan.display_name }}</h3>
            <p class="text-[11px] m-0 mt-0.5 text-secondary/60">{{ plan.tagline }}</p>
          </div>
        </div>

        <div class="flex items-baseline gap-1 my-5 pb-5 border-b border-secondary/10">
          <span class="text-4xl font-extrabold text-[#3a101e]">₹{{ getPrice(plan) }}</span>
          <span class="text-xs font-medium text-secondary/60">{{ getCycleLabel(plan) }}</span>
        </div>

        <button type="button" (click)="selectPlan(plan.plan_code, getPrice(plan))" [disabled]="isPlanCurrent(plan.plan_code)"
          [ngClass]="isPlanCurrent(plan.plan_code) ? 'bg-emerald-700 text-white cursor-default opacity-95' : (plan.plan_code === 'EXPRESS' || plan.plan_code === 'GOLD' ? 'bg-primary text-white hover:bg-primary/90 cursor-pointer shadow-md' : 'bg-white text-primary border-2 border-primary hover:bg-primary/5 cursor-pointer')"
          class="w-full py-3 rounded-xl font-bold text-xs uppercase tracking-wider transition-all shadow-sm border-0">
          {{ isPlanCurrent(plan.plan_code) ? '✨ Current Plan' : (plan.plan_code === 'FREE' ? 'Get Started Free' : 'Upgrade to ' + plan.display_name) }}
        </button>


        <div class="mt-6 space-y-5">
          <div *ngFor="let sec of getPlanSections(plan)">
            <p class="text-[10px] font-extrabold uppercase tracking-widest m-0 mb-2.5 font-mono text-secondary/50">
              {{ sec.category }}
            </p>
            <ul class="space-y-2 m-0 p-0 list-none text-xs text-secondary">
              <li *ngFor="let item of sec.items" class="flex items-start gap-2" [ngClass]="!item.available ? 'text-secondary/60' : ''">
                <span *ngIf="item.available" 
                      class="material-symbols-outlined text-base shrink-0 text-emerald-600">check_circle</span>
                <span *ngIf="!item.available" 
                      class="material-symbols-outlined text-base shrink-0 text-neutral-400">cancel</span>
                <span>{{ item.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Trust Footer Assurance -->
  <div class="mt-20 text-center text-xs text-secondary/60 max-w-xl mx-auto flex items-center justify-center gap-6 border-t border-secondary/10 pt-8">
    <span class="flex items-center gap-1.5"><span class="material-symbols-outlined text-sm text-emerald-600">lock</span> 256-Bit SSL Encrypted</span>
    <span>·</span>
    <span class="flex items-center gap-1.5"><span class="material-symbols-outlined text-sm text-primary">verified_user</span> Instant Activation</span>
    <span>·</span>
    <span>Razorpay Secured Gateway</span>
  </div>
</div>